// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"~views/colors.css\"","easilBlack":"#2c2e2f","preview":"style_preview__2Wo0q","headerSubtitle":"style_headerSubtitle__3KAO3","title":"style_title__1KQj-"};